import styles from './PerformanceTable.module.scss';

export interface PerformanceTableProps {
  className?: string;
}

/**
 * Campaign performance comparison table.
 */
export function PerformanceTable({ className }: PerformanceTableProps) {
  return (
    <div className={className}>
      <div className={styles.container}>
        <p>Performance table coming soon.</p>
      </div>
    </div>
  );
}
